<template>
  <v-app>
    <v-main>
      <div class="container-fluid app-container">
        <div class="row">
          <div class="col-md-8 col-xs-12 col-sm-12 col-12 wrapper-page">
            <div class="row header-page">
              <AHeader />
            </div>
            <div class="row justify-content-center content-page">
              <router-view></router-view>
            </div>
            <div class="row justify-content-center footer-page">
              <AFooter />
            </div>
          </div>
          <div
            class="col-md-4 col-xs-12 col-sm-12 col-12 main-bg-picture"
          ></div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import AHeader from './components/Layout/AHeader.vue';
import AFooter from './components/Layout/AFooter.vue';
import httpClient from '@/services/httpClient';

export default {
  name: 'App',
  components: {
    AHeader,
    AFooter,
  },
  created() {
    this.$store.dispatch('register/checkCookies');
    this.$store.dispatch('visualResources/getVisualResources').then(r => {
      document.getElementById('favicon').href = r.favicon;
      if (r.appName) {
        if (document.title.search(r.appName) === -1) {
          document.title = `${r.appName} - ${document.title}`;
        }
      }
      if (r.primaryColor)
        document.documentElement.style.setProperty(
          '--primary-color',
          r.secondaryColor,
        );
      if (r.secondaryColor)
        document.documentElement.style.setProperty(
          '--secondary-color',
          r.primaryColor,
        );
    });
    // interceptor to catch errors
    const errorInterceptor = error => {
      // check if it's a server error
      if (!error.response) {
        this.$toast.warning('Error de red o de servidor, intente nuevamente');
        return Promise.reject(error);
      }

      // all the other error responses
      switch (error.response.status) {
        case 400:
          this.$toast.error(
            error.response.data.message
              ? error.response.data.message
              : 'Ha ocurrido un error inesperado, intente nuevamente',
          );
          break;

        case 401: // authentication error, logout the user
          this.$toast.error('Error de sesión, inicie sesión nuevamente');
          setTimeout(() => {
            this.$store.dispatch('logout');
          }, 2000);
          break;
        case 500: // Server error
          console.error(error);
          this.$toast.error(
            'Ha ocurrido un error en el servidor, intente nuevamente',
          );
          break;

        default:
          console.error(error);
          this.$toast.error(
            'Ha ocurrido un error inesperado, intente nuevamente',
          );
      }
      return Promise.reject(error);
    };

    // Interceptor for responses
    const responseInterceptor = response => {
      const { data: resp } = response;

      switch (response.status) {
        case 200:
          if (resp.userToken) {
            this.$store.dispatch('register/setToken', {
              username: resp.userId,
              password: resp.userToken,
            });
          }
          break;
        default:
        // default case
      }

      return response;
    };

    httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);
  },
};
</script>

<style lang="sass">
@import "./sass/app.sass"
</style>
